import {
  createTranslatedMessageComponent,
  createUseTranslateMessage,
} from '@bloomberg/media.i18n';

import { labelIds } from '../i18n';

export const useTranslateMessage = createUseTranslateMessage(labelIds);

export const TranslatedMessage = createTranslatedMessageComponent(labelIds);
